@if (loading === false) {
  <portal-main-nav>
    <!-- Home -->
    <portal-main-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_PAGE_GENERAL],
      }"
      icon="far fa-home"
      route="end-user-personalization"
    >
      <span>{{ 'menu.general' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Call Center -->
    @if (hasCallCenter) {
      <portal-main-nav-item icon="far fa-database" route="end-user-call-center">
        <span>{{ 'menu.callCenter' | portalTranslate }}</span>
        <ng-template>
          <portal-end-user-call-center-sub-nav [force]="true"></portal-end-user-call-center-sub-nav>
        </ng-template>
      </portal-main-nav-item>
    }
    <!-- ACD -->
    @if (hasAcd) {
      <portal-main-nav-item icon="far fa-compass" route="end-user-acd-queues">
        <span>{{ 'menu.acdQueues' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Devices -->
    @if (hasDevice && isEndUser === false) {
      <portal-main-nav-item
        *portalIsAuthorized="{
          anyPermission: [Permission.VIEW_DEVICES],
        }"
        icon="far fa-phone-office"
        route="end-user-devices"
      >
        <span>{{ 'menu.devices' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Features -->
    <portal-main-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_PAGE_FEATURES],
      }"
      icon="far fa-sliders-h"
      route="end-user-features"
    >
      <span>{{ 'menu.features' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Phone Book -->
    <portal-main-nav-item icon="far fa-address-book" route="end-user-phone-book">
      <span>{{ 'menu.phonebook' | portalTranslate }}</span>
      <ng-template>
        <portal-end-user-phone-book-sub-nav [force]="true"></portal-end-user-phone-book-sub-nav>
      </ng-template>
    </portal-main-nav-item>
    <!-- Time Tables -->
    <portal-main-nav-item icon="far fa-clock" route="end-user-time-table">
      <span>{{ 'menu.timeTable' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Call Barring -->
    <portal-main-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_USER_ACL],
      }"
      icon="far fa-shield"
      route="end-user-call-barring"
    >
      <span>{{ 'menu.callBarring' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Conference -->
    @if (hasDevice && hasConferenceLicense) {
      <portal-main-nav-item icon="far fa-comments" route="end-user-conference">
        <span>{{ 'menu.conferences' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Messages -->
    <portal-main-nav-item icon="far fa-envelope" route="end-user-messages">
      <span>{{ 'menu.messages' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Call Details -->
    @if (hasDevice) {
      <portal-main-nav-item
        *portalIsAuthorized="{
          anyPermission: [Permission.VIEW_CDR],
        }"
        icon="far fa-phone"
        route="end-user-call-details"
      >
        <span>{{ 'menu.cdr' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Call log -->
    <portal-main-nav-item
      *portalIsAuthorized="{
        allPermissions: [Permission.VIEW_USER_CALL_LOG],
      }"
      icon="far fa-history"
      route="end-user-call-logs"
    >
      <span>{{ 'menu.callLogs' | portalTranslate }}</span>
    </portal-main-nav-item>
    <!-- Rich presence -->
    @if (canUseRichPresence) {
      <portal-main-nav-item icon="far fa-laptop-house" route="end-user-rich-presence-profiles">
        <span>{{ 'menu.richPresenceProfiles' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Teams presence sync -->
    @if (hasMs365Presence) {
      <portal-main-nav-item icon="fab fa-windows" route="end-user-ms365-presence">
        <span>{{ 'menu.ms365Presence' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Soft Clients -->
    @if (hasDevice) {
      <portal-main-nav-item icon="far fa-download" route="end-user-soft-clients">
        <span>{{ 'menu.softClients' | portalTranslate }}</span>
      </portal-main-nav-item>
    }
    <!-- Documentation -->
    <portal-main-nav-item icon="far fa-book" route="end-user-documentation">
      <span>{{ 'menu.documentation' | portalTranslate }}</span>
    </portal-main-nav-item>
  </portal-main-nav>
} @else {
  <div class="main-nav text-center pt-3">
    <i class="far fa-circle-notch fa-spin"></i>
  </div>
}
